import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { FuelRecordDefault, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './fuel-record-default.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class FuelRecordDefaultComponent extends RepositoryModal<FuelRecordDefault> {}
